/**
 * @desc 亚马逊报告处理结果通知
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.platDataFlow.AmzReportRequestNoticeResponseDto, options?: any) {
  return updateResponse(
    http(URL + `/amzReport/noticeResult`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
